/**
 * API Configuration
 * 
 * Centralized API URL configuration using environment variables.
 * Production default: https://tms.ideumagency.com/backend_laravel/public/api
 */

const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  if (process.env.NODE_ENV === 'production') {
    return 'https://tms.ideumagency.com/backend_laravel/public/api';
  }

  return 'http://127.0.0.1:8000/api';
};

export const API = getApiUrl();

// Export for backwards compatibility
export default API;
